<template>
  <section id="contact" class="contact">
    <b-container cols="*">
      <h1>Ihr Anliegen liegt uns am Herzen</h1>
      <b-row>
        <b-col>
          <b-card>
            <b-card-text>
              Wir gestalten ihren Garten um oder gestalten ihn von Grund auf neu!
            </b-card-text>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <b-card-text>
              Wir sind spezialisiert auf Anlegen von Teichen & sonstigen Gewässern.
            </b-card-text>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <b-card-text>
              Wir erstellen genaue Pläne, ermitteln alle Materialien und mögliche Pflanzensorten.
            </b-card-text>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <b-card-text>
              Wir sind bekannt für Raseneinsaat, das Verlegen von Fertigrasen, Betonsteinpflaster & Platten.
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          Kommen Sie einfach zu uns!
          wir helfen Ihnen gerne bei der konkreten Umsetzung Ihrer kreativen Ideen.
          Nehmen Sie mit uns Kontakt auf und wir schicken Ihnen einen unverbindlichen Kostenvoranschlag!
        </b-col>
        <b-col>
          <b-row>
            <div class="contact-value">
              gartenfeewbach@aol.com
            </div>
          </b-row>
          <b-row>
            <div class="contact-value">
              06053-4795
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: 'Contact',
  }
</script>

<style lang="scss">
  @import '../../assets/styles/home/contact.scss';
</style>
